document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-card]').forEach(function(card) {
    var form = card.querySelector('[data-card-form]');
    var btn = card.querySelector('[data-add-to-cart]');
    if (!form || !btn) return;
    var quickAdd = card.querySelector('[data-quick-add]');
    var idInput = form.querySelector('input[name="id"]');
    var isOpen = false;
    var selected = {};
    var optionsData = [];
    var variantsData = [];

    card.addEventListener('mouseleave', function() {
      if (isOpen) closeQuickAdd();
    });

    var overlay = card.querySelector('.card__overlay');

    function closeQuickAdd() {
      isOpen = false;
      if (quickAdd) quickAdd.classList.remove('card__quick-add--open');
      if (overlay) overlay.classList.remove('card__overlay--force');
      selected = {};
    }

    function getSelectedVariant() {
      var vals = Object.values(selected);
      return variantsData.find(function(v) {
        return v.options.every(function(o, i) { return o === vals[i]; });
      });
    }

    function spawnConfetti(b, rect) {
      if (!rect) rect = b.getBoundingClientRect();
      var container = document.createElement('div');
      container.className = 'card__atc-confetti';
      var cx = rect.width / 2;
      var cy = rect.height / 2;
      container.style.left = cx + 'px';
      container.style.top = cy + 'px';
      b.appendChild(container);
      var colors = ['#D4AF37', '#E8C84A', '#F5E6A3', '#FFD700', '#FFF8DC'];
      for (var i = 0; i < 14; i++) {
        var p = document.createElement('div');
        p.className = 'card__atc-confetti-particle';
        var ang = (i / 14) * 360;
        var dist = 20 + Math.random() * 30;
        var tx = Math.cos(ang * Math.PI / 180) * dist;
        var ty = Math.sin(ang * Math.PI / 180) * dist;
        p.style.setProperty('--tx', tx + 'px');
        p.style.setProperty('--ty', ty + 'px');
        p.style.background = colors[i % colors.length];
        p.style.width = (3 + Math.random() * 3) + 'px';
        p.style.height = (3 + Math.random() * 3) + 'px';
        p.style.animationDelay = (Math.random() * 0.1) + 's';
        container.appendChild(p);
      }
      setTimeout(function() { container.remove(); }, 1000);
    }

    function animateBtnSuccess(b, rect) {
      var label = b.querySelector('.card__atc-label');
      if (!label) return;
      var orig = label.textContent;
      var svg = b.querySelector('svg');
      var origSvg = svg ? svg.outerHTML : '';
      if (!rect) rect = b.getBoundingClientRect();
      b.classList.add('card__atc--success');
      spawnConfetti(b, rect);
      if (svg) {
        var check = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        check.setAttribute('class', 'card__atc-check');
        check.setAttribute('width', '16');
        check.setAttribute('height', '16');
        check.setAttribute('viewBox', '0 0 24 24');
        check.setAttribute('fill', 'none');
        check.setAttribute('stroke', 'currentColor');
        check.setAttribute('stroke-width', '2.5');
        check.setAttribute('stroke-linecap', 'round');
        check.setAttribute('stroke-linejoin', 'round');
        check.innerHTML = '<polyline points="20 6 9 17 4 12"/>';
        svg.replaceWith(check);
      }
      label.innerHTML = '<span class="card__atc-added-text">Added</span>';
      setTimeout(function() {
        b.classList.remove('card__atc--success');
        label.innerHTML = orig;
        var check = b.querySelector('.card__atc-check');
        if (check) check.outerHTML = origSvg;
      }, 1800);
    }

    function doAdd(triggerBtn, productTitle, onSuccess) {
      var fd = new FormData(form);
      triggerBtn.disabled = true;
      triggerBtn.classList.add('card__atc--loading');
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function(r) {
          if (!r.ok) throw new Error();
          return r.json();
        })
        .then(function() {
          var btnRect = triggerBtn.getBoundingClientRect();
          triggerBtn.disabled = false;
          triggerBtn.classList.remove('card__atc--loading');
          var isQa = triggerBtn.hasAttribute('data-quick-add-submit');
          if (isQa) {
            triggerBtn.classList.add('card__quick-add-submit--success');
            triggerBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
            setTimeout(function() {
              triggerBtn.classList.remove('card__quick-add-submit--success');
              triggerBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
              if (typeof onSuccess === 'function') onSuccess();
            }, 600);
          } else {
            animateBtnSuccess(triggerBtn, btnRect);
            if (typeof onSuccess === 'function') onSuccess();
          }
          if (typeof showCartToast === 'function') showCartToast(productTitle, triggerBtn.getAttribute('data-product-image'));
          if (typeof openCartDrawer === 'function') openCartDrawer();
          if (typeof updateCartCount === 'function') updateCartCount();
          document.dispatchEvent(new CustomEvent('cart-open', { detail: { title: productTitle } }));
        })
        .catch(function() {
          triggerBtn.disabled = false;
          triggerBtn.classList.remove('card__atc--loading');
          triggerBtn.classList.remove('card__atc--success');
        });
    }

    function openQaPanel() {
      isOpen = true;
      if (overlay) overlay.classList.add('card__overlay--force');
      quickAdd.classList.add('card__quick-add--open');
      try {
        optionsData = JSON.parse(btn.getAttribute('data-options') || '[]');
        variantsData = JSON.parse(btn.getAttribute('data-variants') || '[]');
      } catch (_) {
        closeQuickAdd();
        doAdd(btn, btn.getAttribute('data-product-title'));
        return;
      }
      selected = {};
      var optionsContainer = quickAdd.querySelector('[data-quick-add-options]');
      var priceEl = quickAdd.querySelector('[data-quick-add-price]');
      var qaSubmit = quickAdd.querySelector('[data-quick-add-submit]');
      if (!optionsContainer || !priceEl || !qaSubmit) return;
      priceEl.textContent = 'Add to Cart';
      optionsContainer.innerHTML = '';

      function updatePrice() {
        var v = getSelectedVariant();
        if (v && v.available) {
          qaSubmit.disabled = false;
          priceEl.textContent = v.price_formatted;
          idInput.value = v.id;
        } else {
          qaSubmit.disabled = true;
          priceEl.textContent = v ? 'Sold Out' : 'Select options';
        }
      }

      optionsData.forEach(function(opt, oi) {
        var wrap = document.createElement('div');
        wrap.className = 'card__quick-add-option';
        var title = document.createElement('span');
        title.className = 'card__quick-add-label';
        title.textContent = opt.name;
        wrap.appendChild(title);
        var pills = document.createElement('div');
        pills.className = 'card__quick-add-pills';
        opt.values.forEach(function(val) {
          var pill = document.createElement('button');
          pill.type = 'button';
          pill.className = 'card__quick-add-pill';
          pill.textContent = val;
          pill.addEventListener('click', function(ev) {
            ev.stopPropagation();
            if (this.classList.contains('card__quick-add-pill--active')) {
              this.classList.remove('card__quick-add-pill--active');
              delete selected[oi];
            } else {
              pills.querySelectorAll('.card__quick-add-pill').forEach(function(p) { p.classList.remove('card__quick-add-pill--active'); });
              this.classList.add('card__quick-add-pill--active');
              selected[oi] = val;
            }
            updatePrice();
          });
          pills.appendChild(pill);
        });
        wrap.appendChild(pills);
        optionsContainer.appendChild(wrap);
      });
    }

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.disabled) return;
      var hasVariants = this.getAttribute('data-has-variants') === 'true';
      if (!hasVariants) {
        doAdd(this, this.getAttribute('data-product-title'));
        return;
      }
      if (isOpen) return;
      openQaPanel();
    });

    if (quickAdd) {
      var qaSubmit = quickAdd.querySelector('[data-quick-add-submit]');
      if (qaSubmit) {
        qaSubmit.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.disabled) return;
          var v = getSelectedVariant();
          if (!v || !v.available) return;
          idInput.value = v.id;
          doAdd(this, btn.getAttribute('data-product-title'), function() {
            closeQuickAdd();
          });
        });
      }
    }
  });
});
